import MjSection from "mjml-section-snyk";
import setupMjmlComponent from "../helper/setupMjmlComponent.js";
export default setupMjmlComponent(MjSection, true);
